<template>
  <div
    class="h-screen flex bg-img w-full vx-row no-gutter items-center justify-center"
    id="page-login"
    :style="background_image"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 sm:m-0 m-4">
      <div class="mb-5" id="logo_image">
        <img class="radius" :src="logo ? logo : ''" :width="'100px'" />
      </div>
      <b-card class="mt-5">
        <form>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">{{ $t(title + "Login") }}</h4>
                    <p>{{ $t("LoginWelcome") }}</p>
                  </div>

                  <div>
                    <div>
                      <b-input-group>
                        <template #prepend>
                          <b-input-group-text>
                            <b-icon icon="person"></b-icon>
                          </b-input-group-text>
                        </template>
                        <b-form-input
                          v-validate="'required|email'"
                          name="email"
                          :data-vv-as="$t('Email')"
                          v-model="email"
                          @keydown.enter="handleLogin"
                          :placeholder="$t('Email')"
                        />
                      </b-input-group>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('email')"
                        >{{ errors.first("email") }}</span
                      >
                    </div>
                    <div class="mt-5">
                      <b-input-group>
                        <template #prepend>
                          <b-input-group-text>
                            <b-icon icon="lock"></b-icon>
                          </b-input-group-text>
                        </template>
                        <b-form-input
                          v-validate="'required|min:6'"
                          type="password"
                          name="password"
                          :data-vv-as="$t('Password')"
                          v-model="password"
                          @keydown.enter="handleLogin"
                          :placeholder="$t('Password')"
                        />
                      </b-input-group>

                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('password')"
                        >{{ errors.first("password") }}</span
                      >
                    </div>

                    <label id="password" class="float-right pull-right">
                      <span>
                        <router-link :to="path">{{
                          $t("ForgotPassword")
                        }}</router-link>
                      </span>
                    </label>
                    <br />
                    <!-- <div class="float-right pull-right">
                      <router-link :to="path">{{ $t("ForgotPassword") }}</router-link>
                    </div> -->
                    <b-button
                      id="login"
                      variant="primary"
                      class="w-full mt-5"
                      @click="handleLogin"
                      >{{ $t("Login") }}</b-button
                    >
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </form>
      </b-card>
      <div class="vx-row mt-5" id="logo_image">
        <div class="w-1/2">
          <strong class="float-right mt-1">{{ $t("Language") }}:</strong>
        </div>
        <div class="w-1/2">
          <i18n class="ml-2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import I18n from "@/layouts/components/navbar/components/I18n.vue";
import $ from "jquery";
import { getLocalData, clearLocalData } from "@/utils/auth";

export default {
  props: {
    title: String,
    path: String,
  },
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      loginForm: {},
      // logo: require("@/assets/images/logo/bip.png"),
      logo: "",
      images_data: [],
      background: null,
    };
  },
  components: {
    I18n,
  },
  computed: {
    get_logo() {
      return this.$store.getters.whitelabel.logo.path;
    },
    background_image() {
      let bg = this.$store.getters.whitelabel.background_image.path;
      if (this.background) bg = this.background;
      return {
        "background-image": `url('${bg}')`,
      };
    },
  },
  watch: {
    get_logo: function (newValue) {},
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.displayError();
      },
    },
  },
  created() {
    let currentPath = this.$route.path;
    // if (currentPath == "/company/login") this.getSettings();
    this.$validator.extend("upCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[A-Z]/g) !== null,
    });
    this.$validator.extend("numbers", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[0-9]/g) !== null,
    });
    this.$validator.extend("loCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[a-z]/g) !== null,
    });
    this.loadLocale(this.$i18n.locale);
  },
  mounted() {
    let currentPath = this.$route.path;
    if (currentPath == "/company/login") {
      this.background = require("@/assets/images/work/Company.jpeg");
    }
    if (currentPath == "/user/login") {
      let slug = this.$route.query.company || 0;
      if (slug) {
        localStorage.setItem("client_company_slug", slug);
        let data = {
          company_slug: slug,
        };
        this.$store
          .dispatch("GetCompanyBackgroundForLogin", data)
          .then((res) => {
            this.$vs.loading.close();
            console.log("res.data.data", res.data.data);
            this.images_data = res.data.data;
            this.logo = this.images_data.logo;
            console.log(
              "this.images_data.background_image",
              this.images_data.background_image.path
            );
            this.background = this.images_data.background_image.path;
            if (!this.background)
              this.background = require("@/assets/images/work/User.jpeg");
          });
      } else if (!slug) {
        clearLocalData();
        this.background = require("@/assets/images/work/User.jpeg");
      }
    }
    if (currentPath == "/admin/login") {
      this.background = require("@/assets/images/work/Admin.jpeg");
    }
  },
  methods: {
    // get
    getSettings() {
      this.$store
        .dispatch("GetSystemSettings")
        .then((res) => {
          this.$vs.loading.close();
          this.images_data = res.data.data;
          this.logo = this.images_data.logo.path;
          this.background = this.images_data.background_image.path;
        })
        .catch((error) => {
          this.$log.error(
            "File : getSetting.vue | Function : getSettings() | Error :",
            error
          );
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("Error"),
            text:
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error,
            color: "danger",
            position: "top-center",
          });
          return false;
        });
    },
    //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },
    errorClass(rule) {
      return {
        error: this.errors.firstByRule("password", rule),
      };
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     * login
     */
    async handleLogin() {
      const isOk = await this.$validator.validateAll();
      if (!isOk) {
        return this.$emit("submit", "");
      }

      this.loginForm = {
        email: this.email,
        password: this.password,
        remember_me: this.checkbox_remember_me,
        slug: this.$route.params.slug,
        channel_name: "staffAvailable",
      };
      this.$emit("submit", this.loginForm);
    },
  },
};
</script>
<style scoped>
#password {
  font-size: 0.85rem;
}
#login {
  padding: 0.5rem 1rem;
  border-radius: 5px;
}
</style>
